import { render, staticRenderFns } from "./ImportNewVersion.vue?vue&type=template&id=09f3d69b&scoped=true&"
import script from "./ImportNewVersion.vue?vue&type=script&lang=js&"
export * from "./ImportNewVersion.vue?vue&type=script&lang=js&"
import style0 from "./ImportNewVersion.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ImportNewVersion.vue?vue&type=style&index=1&id=09f3d69b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f3d69b",
  null
  
)

export default component.exports